import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Clear } from '@berlitz/icons'
import { CSSTransition } from 'react-transition-group'
import { Wrapper, Body, RightSidebar, Row, ToggleDrawerButton, CloseToggleButton, ToggleDrawer } from './style'
import { useSelector } from 'react-redux'
import { StoreProps } from '@interfaces/StoreState'

const PageWithRightSidebarTpl = ({ body, sidebar, toggleIcon, sidebarXsOrder, showSidebar, showToggleOnMobile }) => {
  const [showDrawer, setShowDrawer] = useState(false)
  const [showButton, setShowButton] = useState(true)

  const { isAdmin } = useSelector(({ session }: StoreProps) => ({
    isAdmin: session.isAdmin,
  }))

  return (
    <Wrapper sidebarXsOrder={sidebarXsOrder} isAdmin={isAdmin}>
      <Row>
        <Body>{body}</Body>
        {(showSidebar || showToggleOnMobile) && (
          <>
            <ToggleDrawer showToggleOnMobile={showToggleOnMobile}>
              <CSSTransition in={showButton} timeout={300} classNames="enter-right" unmountOnExit>
                <ToggleDrawerButton onClick={() => setShowDrawer(true)}>{toggleIcon}</ToggleDrawerButton>
              </CSSTransition>
              <CSSTransition
                in={showDrawer}
                timeout={300}
                classNames="enter-right"
                unmountOnExit
                onEnter={() => setShowButton(false)}
                onExited={() => setShowButton(true)}
              >
                <RightSidebar>
                  <CloseToggleButton onClick={() => setShowDrawer(false)}>
                    <Clear />
                  </CloseToggleButton>
                  {sidebar}
                </RightSidebar>
              </CSSTransition>
            </ToggleDrawer>
            {!showToggleOnMobile && <RightSidebar className="main">{sidebar}</RightSidebar>}
          </>
        )}
      </Row>
    </Wrapper>
  )
}

PageWithRightSidebarTpl.propTypes = {
  body: PropTypes.element.isRequired,
  sidebar: PropTypes.element.isRequired,
  toggleIcon: PropTypes.element,
  sidebarXsOrder: PropTypes.bool,
  showSidebar: PropTypes.bool,
  showToggleOnMobile: PropTypes.bool,
}

PageWithRightSidebarTpl.defaultProps = {
  showSidebar: true,
}

export default PageWithRightSidebarTpl
